import { libraryService } from './libraryService';
import { ensureLibraryRoutingReady, shouldUseLocalLibraryIpc } from './localLibraryIpcGate';
import { invalidateLocalCatalogForSearchCache } from './unifiedSearchLocal';

let _localSourcesConfigured: boolean | null = null;

export function invalidateLocalLibrarySourcesCache(): void {
  _localSourcesConfigured = null;
  invalidateLocalCatalogForSearchCache();
}

/** True when local-core IPC is available and at least one library source exists. */
export async function hasLocalLibrarySourcesConfigured(force = false): Promise<boolean> {
  if (!shouldUseLocalLibraryIpc()) {
    _localSourcesConfigured = false;
    return false;
  }
  if (!force && _localSourcesConfigured !== null) {
    return _localSourcesConfigured;
  }
  try {
    await ensureLibraryRoutingReady();
    const resp = await libraryService.getSources();
    const sources = Array.isArray(resp?.sources) ? resp.sources : [];
    _localSourcesConfigured = sources.length > 0;
  } catch {
    _localSourcesConfigured = false;
  }
  return _localSourcesConfigured;
}
